import { Box } from "@mui/material";
import { styled } from "@mui/system";

import Navigation from "../../components/root/Navigation";
import NewTop from "../../components/root/NewTop";
import Top from "../../components/root/Top";
import List from "../../components/root/List";
import Roadmap from "../../components/root/Roadmap";
import MidWithMockups from "../../components/root/MidWithMockups"; // New 3D mockups version
import Testimonials from "../../components/root/Testimonials";
import BadgesShowcase from "../../components/root/BadgesShowcase";
import KankiSection from "../../components/root/KankiSection";
import Footer from "../../components/root/Footer";

const RootPage = () => {
    const GradientBox = styled(Box)({
        // background: "rgb(238,174,202)",
        // background: "radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)"
        backgroundImage: "linear-gradient( 0deg,  rgba(115, 174, 252, 1) 6.5%, rgba(82, 163, 255, 1)  100% )",
    });

    return (
        <Box>
            <GradientBox >
                <Navigation />
                <NewTop />
                <Top />
                <Roadmap />
                <List />
                <MidWithMockups />
                <KankiSection />
                <BadgesShowcase />
                <Testimonials />
                <Footer />
            </GradientBox >
        </Box>
    );
};

export default RootPage;
